export class UnknownError extends Error {
    readonly kind = 'UnknownError';
    constructor() {
        super('UnknownError');
    }
}
